import { ActionKeys } from '~/actions/constants';
import { ActionTypes } from '~/actions/index';
import { CarrierFormField } from '~/types/CarrierFormField';

export type CarrierFormFieldsState = {
  readonly carrierFormFields: readonly CarrierFormField[];
  readonly isFetchingCarrierFormFields: boolean;
  readonly errorMessage: string;
  readonly carrierFormFieldValidations: { [key: string]: ((data: string) => void)[] }; // Object contains keys to Array<func>
};

const initialState: CarrierFormFieldsState = {
  carrierFormFields: [],
  isFetchingCarrierFormFields: false,
  errorMessage: '',
  carrierFormFieldValidations: {},
};

function carrierFormFieldsReducer(
  state: CarrierFormFieldsState = initialState,
  action: ActionTypes,
): CarrierFormFieldsState {
  switch (action.type) {
    case ActionKeys.CARRIER_FORM_FIELDS_CLEAR_STATE:
      return {
        ...state,
        errorMessage: '',
        carrierFormFields: [],
        carrierFormFieldValidations: {},
      };
    case ActionKeys.FETCH_CARRIER_FORM_FIELDS:
      return {
        ...state,
        isFetchingCarrierFormFields: true,
      };
    case ActionKeys.FETCH_CARRIER_FORM_FIELDS_SUCCESS:
      return {
        ...state,
        isFetchingCarrierFormFields: false,
        carrierFormFields: action.payload.carrierFormFields,
        carrierFormFieldValidations: action.payload.carrierFormFieldValidations,
      };
    case ActionKeys.FETCH_CARRIER_FORM_FIELDS_ERROR:
      return {
        ...state,
        isFetchingCarrierFormFields: false,
        errorMessage: action.payload.error,
      };
    default:
      return state;
  }
}

export default carrierFormFieldsReducer;
